import { TEMPLATES } from "./email-templates.constant";

export class EmailTemplateService {
    getTemplate(temp, title, text) {
        let mainTemplate = TEMPLATES[temp];
        mainTemplate = mainTemplate.replace(/###TITLE PLACEHOLDER###/g, title);
        mainTemplate = mainTemplate.replace(/###TEXT PLACEHOLDER###/g, text);

        return mainTemplate;
    }

    replaceItems(template, title, text) {
        template = template.replace(/<PHOTOS>/g, TEMPLATES.photosPreview);
        template = template.replace(/LIVE_URL/g, "https://live.upreach.com/{{uid}}");
        template = template.replace(/<TITLE>/g, this.getTitle(title));
        template = template.replace(/<TEXT>/g, this.getText(text));
        return template;
    }

    getTitle(title) {
        return `<tr>
			<td bgcolor="#141414" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td bgcolor="#141414" style="font-size:28px; line-height: 33px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color: #ffffff; font-weight: bold; text-align: center; padding-top: 0px; padding-bottom: 0px;" valign="top" align="center">
						<p>${title}</p>
					</td>
				</table>
			</td>
		</tr>`;
    }

    getText(text) {
        return `<table cellspacing="0" cellpadding="0" border="0" width="100%">
            <tbody>
        
                <tr>
                    <td bgcolor="#f5f7f8" align="center" valign="top">
        
                        <table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
                            <td bgcolor="#f5f7f8" style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#000000; text-align: center; padding-bottom: 25px;" valign="top" align="center">
                                <p>${text}</p>
                            </td>
                        </table>
                    </td>
                    <!-- Change the background color in bgcolor="insert color here"-->
                </tr>
            </tbody>
	    </table>`;
    }

    addLineBreaks(text) {
        return text.replace(/\n/g, "<br/>");
    }

    removeLineBreaks(text) {
        return text.replace(/<br\/>/g, "\n");
    }
}


// WEBPACK FOOTER //
// ./sources/services/configuration/email-template.js